import script from "./Basket.vue?vue&type=script&setup=true&lang=ts"
export * from "./Basket.vue?vue&type=script&setup=true&lang=ts"

import "./Basket.vue?vue&type=style&index=0&id=2671df6a&lang=scss"

const __exports__ = script;

export default __exports__